import data from "../../.sourceflow/job_resources.json";

export const useJobResources = () => {
  const jobTypeLabels = {
    "11282177-5685-48e6-84d9-409a3dcc2d42": "Contract",
    "375d0501-da2c-49e9-9bab-a8cb27e52180": "Permanent",
  };

  const jobs = (data?.category_values || []).map((item) => ({
    Title: item.title?.en || "",
    Image: { url: item.image?.en || "" },
    "Job Type": (item.job_type?.en || []).map((id) => jobTypeLabels[id] || id),
    "Publish Date": item.publish_date?.en || "",
    Content: item.content?.en || "",
    url_slug: item.url_slug || "", // crucial field
  }));

  console.log("useJobResources → jobs:", jobs); // 🔍 Log job entries
  return jobs;
};

export default useJobResources;
